import { Injectable } from "@angular/core";
import { Logger } from "../helper/logger";
import { Store } from "@ngrx/store";
import { httpsCallable, HttpsCallableResult } from "firebase/functions";
import { Functions } from "@angular/fire/functions";
import { Rate } from "shippo";
import { onCallFunctions } from "../../../globalTypes/backend.api.types";
import { MatSnackBar } from "@angular/material/snack-bar";
import { GetRatesForTemporaryParcelChangesVariables } from "../../../globalTypes/onCall.types";
import { ListingPublic } from "../../../globalTypes/listings.types";
import { ShippableBase } from "../../../globalTypes/order.types";

const log = new Logger("ShippingService")
@Injectable({
  providedIn: 'root'
})
export class ShippingService {

  constructor(
    private snackBar: MatSnackBar,
    private functions: Functions,
  ){}

  async getRatesForOrder(orderId: string, onlyShippingLotId?: string): Promise<{[orderItemId:string]:Rate[]}>{
    const callable = httpsCallable(this.functions,  onCallFunctions.getRatesForOrder);
    try {
      const result: HttpsCallableResult = await callable({orderId, onlyShippingLotId}).catch(e=>{
        log.error("Error calling getRatesForOrder with orderId "+orderId, e)
        throw e;
      })
      const rates = result.data as {[orderItemId:string]:Rate[]} & {error?: string};
      log.log({rateRtn: rates})
      if("error" in rates && typeof rates.error === "string"){
        this.snackBar.open(rates.error, "Close", {duration: 15000}) 
        const errorStr = rates.error || "Unknown error getting shipping rates for order "+orderId;
        throw new Error(errorStr);
      }
      return rates;
    } catch(e){
      log.error("Error getting shipping rates for order "+orderId, e)
      throw e;
    }
  }

  async getRatesForTemporaryParcelChanges(shipmentLotId: string, parcels: (Partial<ListingPublic & {id: string, shippingProcessorParcelId: string}>)[] = []): Promise<Rate[]>{
    const callable = httpsCallable(this.functions,  onCallFunctions.getRatesForTemporaryParcelChanges);
    try {
      const vars: GetRatesForTemporaryParcelChangesVariables = {
        shipmentLotId,
        parcels
      }
      const result: HttpsCallableResult = await callable(vars).catch(e=>{
        log.error("Error calling getRatesForTemporaryParcelChanges with shipmentLotId "+shipmentLotId, e)
        throw e;
      })
      const rates = result.data as Rate[] & {error?: string};
      log.log({rateRtn: rates})
      if("error" in rates && typeof rates.error === "string"){
        this.snackBar.open(rates.error, "Close", {duration: 15000}) 
        const errorStr = rates.error || "Unknown error getting shipping rates for shipment lot "+shipmentLotId;
        throw new Error(errorStr);
      }
      return rates;
    } catch(e){
      log.error("Error getting shipping rates for temporary parcel changes for shipment lot "+shipmentLotId, e)
      throw e;
    }
  }


  async getShippingProviderAddressId(address:{
    name: string,
    state: string,
    street1: string,
    streetNo: string,
    city: string,
    country: string,
    zip: string,
    phone: string,
    email: string,
  }
  ): Promise<string>{
    const callable = httpsCallable(this.functions,  onCallFunctions.getShippoAddressId);
    const results: HttpsCallableResult = await callable({address});
    console.log({getShippoAddressIdResults: results})
    return results.data as string;
  }
}